module.exports = __webpack_public_path__ + "img/calendar2.3623acd4.svg";